import { Component } from '@angular/core';
import { ReportDownloadData } from 'src/app/shared/models/reports/report-download';
import { ReportType } from 'src/app/utils/reportType';
import { AuthenticatedUserService } from 'src/app/core/services/authenticated-user/authenticated-user.service';

@Component({
  selector: 'app-download-reports',
  templateUrl: './download-reports.component.html',
  styleUrls: ['./download-reports.component.scss'],
})
/**
 * Download Reports Component
 */
export class DownloadReportsComponent {
  loading: boolean = false;
  transactionReportData: ReportDownloadData = {
    title: 'transaction-report',
    type: ReportType.TRANSACTIONS,
    triggersModal: true,
    display: true,
  };
  censusReportData: ReportDownloadData = {
    title: 'census-report',
    type: ReportType.CENSUS,
    triggersModal: true,
    display: true,
  };
  couponReportData: ReportDownloadData = {
    title: 'coupon-report',
    type: ReportType.COUPONS,
    triggersModal: true,
    display: true,
  };
  vipReportData: ReportDownloadData = {
    title: 'vip-coupon-report',
    type: ReportType.VIP_COUPONS,
    triggersModal: false,
    display: true,
  };
  businessReportData: ReportDownloadData = {
    title: 'businesses-report',
    type: ReportType.BUSINESS_PROFILE,
    triggersModal: false,
    display: this.authenticatedUserService.isGlobalAdmin(),
  };
  representativesReportData: ReportDownloadData = {
    title: 'representatives-report',
    type: ReportType.REPRESENTATIVE_PROFILE,
    triggersModal: false,
    display: this.authenticatedUserService.isGlobalAdmin(),
  };
  warrantyReportData: ReportDownloadData = {
    title: 'warranty-report',
    triggersModal: false,
    url: true,
    display: true,
  };
  pointTransationReportData: ReportDownloadData = {
    title: 'point-transaction-report',
    type: ReportType.POINT_TRANSACTIONS,
    triggersModal: true,
    display: true,
  };
  expiringPointsReportData: ReportDownloadData = {
    title: 'expiring-points-report',
    type: ReportType.EXPIRING_POINTS,
    triggersModal: false,
    display: this.authenticatedUserService.isGlobalAdmin(),
  };

  reportData = [
    this.transactionReportData,
    this.censusReportData,
    this.couponReportData,
    this.vipReportData,
    this.businessReportData,
    this.representativesReportData,
    this.pointTransationReportData,
    this.expiringPointsReportData,
    this.warrantyReportData,
  ];

  /**
   * @constructor
   */
  constructor(
    private readonly authenticatedUserService: AuthenticatedUserService
  ) {}

  /**
   * get event from download report item
   * @param {boolean} $event
   */
  loadingEvent($event: boolean) {
    this.loading = $event;
  }
}
